// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.date-input-container[data-v-0c7c244f] {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n.date-separator[data-v-0c7c244f] {\n  font-size: 1.2rem;\n  font-weight: bold;\n  color: #757575;\n}\n.date-field.short[data-v-0c7c244f] {\n  width: 145px;\n}\n.date-field.long[data-v-0c7c244f] {\n  width: 170px;\n}\n[data-v-0c7c244f] .v-text-field input {\n  text-align: center;\n}\n", ""]);
// Exports
module.exports = exports;
